import React from 'react';
import { AdminLayout } from './AdminLayout';

export function SettingsLayout({ children }) {
  return (
    <AdminLayout>
      {children}
    </AdminLayout>
  );
}
